// Wait for Lenis and GSAP to be available
if (typeof Lenis === 'undefined' || typeof gsap === 'undefined') {
    console.warn('Lenis or GSAP not loaded, delaying carousel initialization');
    window.addEventListener('load', initCarousel);
} else {
    initCarousel();
}

function initCarousel() {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);

    gsap.registerPlugin(ScrollTrigger);
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);
    
    setupScrollAnimations();
    setupCarousel();
    setupPaladinoProductForm();
}

function setupPaladinoProductForm() {
    document.querySelectorAll('[data-product-root]').forEach((root) => {
        if (root.dataset.productBound === 'true') return;

        const optionGroups = Array.from(root.querySelectorAll('[data-product-option]'));
        const variantInput = root.querySelector('[data-product-variant-id]');
        const priceNode = root.querySelector('[data-product-price]');
        const variantLabelNode = root.querySelector('[data-product-variant-label]');
        const submitButton = root.querySelector('[data-product-submit]');
        const submitText = root.querySelector('[data-add-to-cart-text]');
        const sellingPlanInput = root.querySelector('[data-product-selling-plan]');
        const variantDataNode = root.querySelector('[data-product-variants]');

        if (!variantInput || !submitButton || !submitText || !variantDataNode) return;

        let variants = [];

        try {
            variants = JSON.parse(variantDataNode.textContent);
        } catch (error) {
            console.error('Unable to parse Paladino variants', error);
            return;
        }

        const getSelectedOptions = () => optionGroups.map((group) => {
            const selectedRadio = group.querySelector('input[type="radio"]:checked');
            return selectedRadio ? selectedRadio.value : '';
        });

        const findVariant = (selectedOptions) => variants.find((variant) => {
            return selectedOptions.every((value, index) => value && variant[`option${index + 1}`] === value);
        });

        const updateOptionAvailability = () => {
            if (!optionGroups.length) return;

            optionGroups.forEach((group, groupIndex) => {
                const radios = Array.from(group.querySelectorAll('input[type="radio"]'));

                radios.forEach((radio) => {
                    const candidateOptions = getSelectedOptions();
                    candidateOptions[groupIndex] = radio.value;

                    const variantExists = variants.some((variant) => {
                        return candidateOptions.every((value, index) => variant[`option${index + 1}`] === value);
                    });

                    radio.disabled = !variantExists;
                });

                const checkedRadio = group.querySelector('input[type="radio"]:checked');
                if (!checkedRadio || checkedRadio.disabled) {
                    const firstAvailableRadio = radios.find((radio) => !radio.disabled);
                    if (firstAvailableRadio) firstAvailableRadio.checked = true;
                }
            });
        };

        const updateFormState = () => {
            updateOptionAvailability();

            const selectedOptions = getSelectedOptions();
            const currentVariant = findVariant(selectedOptions);

            if (!currentVariant) {
                variantInput.value = '';
                submitButton.disabled = true;
                submitButton.setAttribute('aria-disabled', 'true');
                submitText.textContent = 'Unavailable';
                if (variantLabelNode) variantLabelNode.textContent = '';
                return;
            }

            variantInput.value = currentVariant.id;

            if (priceNode) {
                priceNode.textContent = currentVariant.formatted_price;
            }

            if (variantLabelNode) {
                variantLabelNode.textContent = currentVariant.title && currentVariant.title !== 'Default Title'
                    ? `/ ${(currentVariant.title).split(' / ')[0]}`
                    : '';
            }

            submitButton.disabled = !currentVariant.available;
            submitButton.setAttribute('aria-disabled', currentVariant.available ? 'false' : 'true');
            submitText.textContent = currentVariant.available ? 'Add to Cart' : 'Unavailable';
        };

        optionGroups.forEach((group) => {
            group.querySelectorAll('input[type="radio"]').forEach((input) => {
                input.addEventListener('change', updateFormState);
            });
        });

        // Force direct checkout (capture phase, before theme slideout handlers)
        const directCheckout = async (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }

            if (submitButton.disabled) return;

            const variantId = variantInput.value;
            if (!variantId) return;

            const quantityInput = root.querySelector('input[name="quantity"]');
            const quantity = Math.max(1, Number(quantityInput?.value || 1));

            const originalText = submitText.textContent;
            submitButton.disabled = true;
            submitButton.setAttribute('aria-disabled', 'true');
            submitText.textContent = 'Redirecting…';

            try {
                const item = { id: Number(variantId), quantity };

                if (sellingPlanInput && sellingPlanInput.checked && sellingPlanInput.value) {
                    item.selling_plan = Number(sellingPlanInput.value);
                }

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({ items: [item] })
                });

                if (!response.ok) throw new Error('Add to cart failed');

                window.location.assign('/checkout');
            } catch (error) {
                console.error('Direct checkout failed', error);
                submitButton.disabled = false;
                submitButton.setAttribute('aria-disabled', 'false');
                submitText.textContent = originalText;
            }
        };

        // Intercept both submit and click so drawer scripts never fire
        root.addEventListener('submit', directCheckout, true);
        submitButton.addEventListener('click', directCheckout, true);

        root.dataset.productBound = 'true';
        updateFormState();
    });
}

function setupScrollAnimations() {
    document.querySelectorAll('.reveal').forEach(el => {
        gsap.to(el, {
            opacity: 1, y: 0, duration: 0.9, ease: 'power3.out',
            scrollTrigger: { trigger: el, start: 'top 88%', once: true }
        });
    });

    document.querySelectorAll('.reveal-left').forEach(el => {
        gsap.to(el, {
            opacity: 1, x: 0, duration: 1, ease: 'power3.out',
            scrollTrigger: { trigger: el, start: 'top 85%', once: true }
        });
    });

    document.querySelectorAll('.reveal-right').forEach(el => {
        gsap.to(el, {
            opacity: 1, x: 0, duration: 1, ease: 'power3.out',
            scrollTrigger: { trigger: el, start: 'top 85%', once: true }
        });
    });

    document.querySelectorAll('.grid').forEach(grid => {
        const cards = grid.querySelectorAll('.reveal');
        if (cards.length > 2) {
            gsap.to(cards, {
                opacity: 1, y: 0, duration: 0.7, stagger: 0.1, ease: 'power3.out',
                scrollTrigger: { trigger: grid, start: 'top 85%', once: true }
            });
        }
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => {
            el.style.opacity = 1; el.style.transform = 'none';
        });
    }
}

function setupCarousel() {
    const track = document.getElementById('carouselTrack');
    const dotsWrap = document.getElementById('carouselDots');
    if (!track) {
        console.warn('Carousel track not found');
        return;
    }
    
    const slides = track.querySelectorAll('.carousel-slide');
    const total = slides.length;
    let current = 0;
    let autoTimer;

    // Build dots
    slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'w-2 h-2 rounded-full transition-all duration-300 ' + (i === 0 ? 'bg-white w-5' : 'bg-white/40');
        dot.onclick = () => goTo(i);
        dotsWrap.appendChild(dot);
    });

    function goTo(idx) {
        current = ((idx % total) + total) % total;
        track.style.transform = `translateX(-${current * 100}%)`;
        dotsWrap.querySelectorAll('button').forEach((d, i) => {
            d.className = 'h-2 rounded-full transition-all duration-300 ' + (i === current ? 'bg-white w-5' : 'bg-white/40 w-2');
        });
        resetAuto();
    }

    window.carouselNext = () => goTo(current + 1);
    window.carouselPrev = () => goTo(current - 1);

    function resetAuto() {
        clearInterval(autoTimer);
        autoTimer = setInterval(() => goTo(current + 1), 4500);
    }
    
    resetAuto();
}